import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import agent from "../../app/api/agent";
import { DropdownItemProps, Form, Loader, Select } from "semantic-ui-react";
import { Internship } from "./types";

interface Props {
  isDisabled?: boolean;
  onChange: (value: Internship) => void;
}

const DuplicateInternshipDropdown = ({ isDisabled, onChange }: Props) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<Array<DropdownItemProps & { internship: Internship }> | undefined>(undefined);

  useEffect(() => {
    agent.Internships.listMyInternships().then((response) => {
      setOptions(
        response.items
          .filter((internship, index, self) => self.findIndex((s) => s.title === internship.title) === index)
          .map((internship) => ({
            key: internship.id,
            value: internship.id,
            text: internship.title,
            internship,
          }))
      );
    });
  }, []);

  const isLoading = options == null;

  const handleChange = (id: number) => {
    const internship = options?.find((option) => option.value === id)?.internship;
    onChange(internship!);
  };

  return (
    <Form.Field>
      <Select
        icon={isLoading ? <Loader active /> : undefined}
        disabled={isDisabled}
        options={options ?? []}
        search
        value={""}
        placeholder={t("internship.form.copy_data")}
        onChange={(_, data) => handleChange(data.value as number)}
        selectOnBlur={false}
      />
    </Form.Field>
  );
};

export default DuplicateInternshipDropdown;
